
export const INITIAL_STATE = {
  displayPopUp: false,
  modalTitle: 'The information on this page has not been saved',
  formStateSaved: true,
  path: ''
};

const LeftNavModalData = { INITIAL_STATE };
export default LeftNavModalData;